import { devConfig } from '../config';
import { getCookie } from '../components/utils';
import { apiServer } from './index';

const BASE_URL = `${devConfig.API_HOST}/api/v1/users`;
const headers = {
  'Content-Type': 'application/json',
};
if (localStorage.getItem('access')) {
  headers['Authorization'] = `Bearer ${localStorage.getItem('access')}`;
}
const CAPTCHA_URL = `${devConfig.API_HOST}/api/v1/users/verify-captcha`;

function login(userData) {
  return fetch(`${BASE_URL}/login/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(userData),
  });
  // .then(r => r.json())
  // .then(({ access, refresh, success, influencer, brand, user_type, email }) => {
  //     if (access && refresh && success) {
  //         localStorage.setItem('access', access)
  //         localStorage.setItem('refresh', refresh)
  //         const user = {
  //             email,
  //             user_type,
  //             influencer,
  //             brand
  //         }
  //         localStorage.setItem('user', JSON.stringify(user))
  //         return user
  //     }
  //     return null
  // })
}

function signUp(userData) {
  userData['nomination_id'] = getCookie('nomination_form_id');
  return fetch(`${BASE_URL}/signup`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(userData),
  });
  // .then(r => r.json())
  // .then(({ access, refresh, success, influencer, brand, user_type, email }) => {
  //     if (access && refresh && success) {
  //         localStorage.setItem('access', access)
  //         localStorage.setItem('refresh', refresh)
  //         const user = {
  //             email,
  //             user_type,
  //             influencer,
  //             brand
  //         }
  //         localStorage.setItem('user', JSON.stringify(user))
  //         return user
  //     }
  //     return null
  // })
}

function facebookLogin(data) {
  data['nomination_id'] = getCookie('nomination_form_id');
  return fetch(`${BASE_URL}/facebook/registration`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  })
    .catch((error) => {})
    .then((r) => r.json())
    .then(
      ({
        access,
        refresh,
        success,
        influencer,
        brand,
        user_type,
        email,
        first_name,
        last_name,
        created,
      }) => {
        if (access && refresh && success) {
          localStorage.setItem('access', access);
          localStorage.setItem('refresh', refresh);
          const user = {
            first_name,
            last_name,
            email,
            user_type,
            influencer,
            brand,
          };
          localStorage.setItem('user', JSON.stringify(user));
          // `created` says this social account just signed up rather than
          // signed in. It is a one-off signal for the caller, so it rides
          // on the return value instead of being stored with the user.
          return { ...user, created: Boolean(created) };
        }
      },
    );
}

function clearSession() {
  // Whatever was signed in before is not who is signing in now.
  try {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user');
  } catch (e) {
    // Private mode or a blocked store: nothing to clear, nothing to fix.
  }
}

/**
 * Sign in with a code from the direct Instagram Login redirect.
 *
 * Separate endpoint from facebookLogin: the code is redeemed against
 * Instagram, not Facebook, and yields a different kind of token.
 */
function instagramLogin(code, redirectUri) {
  const body = { code, nomination_id: getCookie('nomination_form_id') };
  if (redirectUri) body.redirect_uri = redirectUri;
  // Deliberately NOT `headers`: that object captures the Authorization
  // token once, at module load. Signing in with a stale token still in
  // localStorage made the backend treat the old session as the owner of
  // this sign-in, which linked a creator's Instagram to an unrelated
  // account. This is a sign-in, so it is sent unauthenticated -- the
  // backend now decides ownership from the Instagram account itself, and
  // clearSession below stops a half-finished old session leaking in.
  clearSession();
  return fetch(`${BASE_URL}/instagram/registration`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then((r) => r.json())
    .then((payload) => {
      const { access, refresh, success, influencer, brand, user_type, email,
        first_name, last_name, created, message } = payload || {};
      if (!(access && refresh && success)) {
        // Surfaced rather than swallowed: the backend's message names what
        // the creator has to fix (no professional account, declined
        // permission), and a silent undefined told them nothing.
        throw new Error(message || 'Instagram sign-in failed. Please try again.');
      }
      localStorage.setItem('access', access);
      localStorage.setItem('refresh', refresh);
      const user = { first_name, last_name, email, user_type, influencer, brand };
      localStorage.setItem('user', JSON.stringify(user));
      return { ...user, created: Boolean(created) };
    });
}

function youtubeLogin(data) {
  data['nomination_id'] = getCookie('nomination_form_id');
  return fetch(`${BASE_URL}/youtube/registration`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((r) => r.json())
    .then(
      ({
        access,
        refresh,
        success,
        influencer,
        brand,
        user_type,
        email,
        first_name,
        last_name,
        created,
      }) => {
        if (access && refresh && success) {
          localStorage.setItem('access', access);
          localStorage.setItem('refresh', refresh);
          const user = {
            first_name,
            last_name,
            email,
            user_type,
            influencer,
            brand,
          };
          localStorage.setItem('user', JSON.stringify(user));
          // `created` says this social account just signed up rather than
          // signed in. It is a one-off signal for the caller, so it rides
          // on the return value instead of being stored with the user.
          return { ...user, created: Boolean(created) };
        }
      },
    );
}

export function brandFacebookConnect(data) {
  return apiServer.post('users/brand/facebook/connect', JSON.stringify(data));
}

export function brandYoutubeConnect(data) {
  return apiServer.post('users/brand/youtube/connect', JSON.stringify(data));
}

export function getCurrentUser() {
  return apiServer.get(`users/current_user`)
}

export function changeBrand(brandId) {
  return apiServer.patch('users/change_brand/', JSON.stringify({ brand_id: brandId }));
}

export function searchBrands(q = '') {
  return apiServer.get(`users/brands/?q=${encodeURIComponent(q)}`);
}

export function setBrands(brandIds) {
  return apiServer.put('users/brands/select/', JSON.stringify({ brand_ids: brandIds }));
}

function youtubeBrandLogin(data) {
  data['nomination_id'] = getCookie('nomination_form_id');
  return fetch(`${BASE_URL}/brand/youtube/registration`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((r) => r.json())
    .then(
      ({
        access,
        refresh,
        success,
        influencer,
        brand,
        user_type,
        email,
        first_name,
        last_name,
        error
      }) => {
        if (access && refresh && success) {
          localStorage.setItem('access', access);
          localStorage.setItem('refresh', refresh);
          const user = {
            first_name,
            last_name,
            email,
            user_type,
            influencer,
            brand,
          };
          localStorage.setItem('user', JSON.stringify(user));
          return { user };
        } else {
          return { error };
        }
      },
    );
}

export function resetPassword(data) {
  return fetch(`${BASE_URL}/password-reset/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  })
}

export function confirmResetPassword(uid, token, data) {
  return fetch(`${BASE_URL}/password-reset-confirm/${uid}/${token}/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  })
}

function sendEmailOTP(email) {
  return fetch(`${BASE_URL}/send_email_code/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ email }),
  });
}

function verifyEmailOTP(email, code) {
  return fetch(`${BASE_URL}/verify_email_code/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ email, code }),
  });
}

export function verifyCaptchaToken(turnstileToken) {
  return fetch(`${CAPTCHA_URL}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: turnstileToken }),
  })
    .then((r) => r.json())
    .then(({ success }) => {
      return success;
    });
}

export const authHandlers = {
  instagramLogin,
  login,
  signUp,
  facebookLogin,
  youtubeLogin,
  youtubeBrandLogin,
  resetPassword,
  confirmResetPassword,
  sendEmailOTP,
  verifyEmailOTP,
};
